import { handleResponse, handleError } from "./apiUtils";
const baseUrl = (process.env.REACT_APP_API_URL || "") + "/api/country/";

export function getCountries() {
  return fetch(baseUrl, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}
